<template>
    <div class="t2-banner t6_sub_banner swzx_banner">
        <div class="container">
            <div class="t2_banner_name">
                <h1>税务中心</h1>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
</style>
